import { ICollaboration } from '@descomplica/microfrontend-core';
import { injectable } from 'tsyringe';

import { PegasusGatewayResponse } from '@/application/interfaces/classroom/pegasus-gateway-response';
import { PegasusGateway } from '@/infrastructure/gateways/classroom/pegasus.gateway';

import {
  LessonNotFound,
  LessonProgressNotRecordedBecauseStudentNotFound,
  LessonProgressRecordedAndVideoProgressRecordedBecauseWasComplete,
  LessonProgressRecordedBecauseWasComplete,
  LessonVideoProgressRecordedBecauseWasComplete,
  ProgressNotRecordedBecauseWasComplete,
  ProgressNotRecordedBecauseWasNotComplete,
  RecordLessonProgressUnexpectedError,
  RequiredUsageNotSent,
  UnexpectedException,
} from './record-lesson-progress-collaboration.responses';

interface Params {
  guidVideo: string;
  usage: number;
  guidCourse: string;
  student: string;
}

const REQUIRED_USAGE_NOT_SENT = 'RequiredUsageNotSent';
const LESSON_NOT_FOUND = 'LessonNotFound';
const LESSON_PROGRESS_NOT_RECORDED_BECAUSE_STUDENT_NOT_FOUND =
  'LessonProgressNotRecordedBecauseStudentNotFound';
const PROGRESS_NOT_RECORDED_BECAUSE_WAS_COMPLETE = 'ProgressNotRecordedBecauseWasComplete';
const PROGRESS_NOT_RECORDED_BECAUSE_WAS_NOT_COMPLETE = 'ProgressNotRecordedBecauseWasNotComplete';
const LESSON_VIDEO_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE =
  'LessonVideoProgressRecordedBecauseWasComplete';
const RECORD_LESSON_PROGRESS_UNEXPECTED_ERROR = 'RecordLessonProgressUnexpectedError';
const LESSON_PROGRESS_RECORDED_AND_VIDEO_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE =
  'LessonProgressRecordedAndVideoProgressRecordedBecauseWasComplete';
const UNEXPECTED_EXCEPTION = 'UnexpectedException';
const LESSON_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE = 'LessonProgressRecordedBecauseWasComplete';

@injectable()
export class RecordLessonProgressCollaboration
  implements ICollaboration<Params, Promise<PegasusGatewayResponse | undefined>>
{
  constructor(private pegasusGateway: PegasusGateway) {}

  async run({ guidCourse, guidVideo, usage, student }: Params): Promise<any> {
    const { data, error } = await this.pegasusGateway.recordLessonProgress(
      guidCourse,
      guidVideo,
      usage,
      student,
    );

    if (data && !error) {
      switch (data.identifier) {
        case PROGRESS_NOT_RECORDED_BECAUSE_WAS_COMPLETE:
          return new ProgressNotRecordedBecauseWasComplete();
        case LESSON_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE:
          return new LessonProgressRecordedBecauseWasComplete();
        case PROGRESS_NOT_RECORDED_BECAUSE_WAS_NOT_COMPLETE:
          return new ProgressNotRecordedBecauseWasNotComplete();
        case LESSON_VIDEO_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE:
          return new LessonVideoProgressRecordedBecauseWasComplete();
        case LESSON_PROGRESS_RECORDED_AND_VIDEO_PROGRESS_RECORDED_BECAUSE_WAS_COMPLETE:
          return new LessonProgressRecordedAndVideoProgressRecordedBecauseWasComplete();
      }
    }

    if (error) {
      switch (error.data.identifier) {
        case LESSON_PROGRESS_NOT_RECORDED_BECAUSE_STUDENT_NOT_FOUND:
          return new LessonProgressNotRecordedBecauseStudentNotFound();
        case RECORD_LESSON_PROGRESS_UNEXPECTED_ERROR:
          return new RecordLessonProgressUnexpectedError();
        case UNEXPECTED_EXCEPTION:
          return new UnexpectedException();
        case REQUIRED_USAGE_NOT_SENT:
          return new RequiredUsageNotSent();
        case LESSON_NOT_FOUND:
          return new LessonNotFound();
      }
    }
  }
}
